import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { Tooltip, makeStyles } from "@material-ui/core";
import { ReactComponent as CartIcon } from "../../../assets/images/cart.svg";
import React from "react";
import { CustomDialog, TextAlertDialog } from "@cabinet-packages/components";
import { addAssayToOrderList, removeAssayFromOrderList } from "@cabinet-packages/redux";
import { useDispatch, useSelector } from "react-redux";
import { designTokens } from "../../../styles/designTokens";
import { useCollectionPointsReset } from "../hooks/useCollectionPointsReset";
import { calculateDiscountedPrice } from "../helpers/priceUtils";

const useStyles = makeStyles({
    cartIcon: {
        color: designTokens.colors.grey[500],
    },
    deleteIcon: {
        color: designTokens.colors.red.main,
    },
});

const AddRemoveIconButtons = ({ item, isIncludedInOrderingList, actionInOrderList, handleChecked, ceil }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { themeMaterialUI } = useSelector(state => state.theme);
    const { takeId } = useSelector(state => state.assaysCatalog);
    const { resetCollectionPoints, isDoctor } = useCollectionPointsReset(ceil);

    const handleAdd = (event) => {
        event.stopPropagation();
        event.preventDefault();

        if (takeId === 14 && window.dataLayer) {
            window.dataLayer.push({
                event: 'add_to_cart',
                eventProps: {
                    items: [{
                        id: item.id,
                        name: item.name,
                        variant: item.type,
                        price: item.discount
                            ? ceil ? Math.ceil(item.price - item.price * item.discount / 100) : item.price - item.price * item.discount / 100
                            : item.price,
                        quantity: 1,
                    }],
                },
                coupon: '',
            });
        }

        resetCollectionPoints();

        if (actionInOrderList && actionInOrderList.length > 0) {
            CustomDialog(TextAlertDialog, {
                text: 'Акційні пропозиції можна замовити тільки в певних пунктах. ' +
                    'Замовте вибрану акцію, та повторіть процедуру для наступної.'
            }, false, themeMaterialUI);
            return;
        }

        dispatch(addAssayToOrderList(
            item.id,
            calculateDiscountedPrice(item.price, item.discount, isDoctor, ceil),
            () => {},
            item.type,
        ));
    };

    const handleRemove = (event) => {
        event.stopPropagation();
        event.preventDefault();

        if (handleChecked) handleChecked({ target: { checked: false, name: 'checkedA' } });

        resetCollectionPoints();

        dispatch(removeAssayFromOrderList(
            item.id,
            calculateDiscountedPrice(item.price, item.discount, isDoctor, ceil),
            () => {},
            item.type,
        ));

        if (handleChecked) handleChecked({ target: { checked: true, name: 'checkedA' } });
    };

    if (!item || item.price <= 0) return null;

    return (
        <Tooltip
            title={isIncludedInOrderingList ? "Натисніть щоб прибрати iз замовлення." : "Натисніть щоб добавити до замовлення."}
            arrow>
            {isIncludedInOrderingList ? (
                <IconButton
                    disabled={+item.idParent === +takeId}
                    onClick={handleRemove}
                >
                    <DeleteIcon className={classes.deleteIcon} />
                </IconButton>
            ) : (
                <IconButton
                    onClick={handleAdd}
                >
                    <CartIcon className={classes.cartIcon} />
                </IconButton>
            )}
        </Tooltip>
    );
};

export default AddRemoveIconButtons;
